import { ApiResult } from 'common/models/api-service/api-result.model';
import { HttpClient } from 'common/services/http-client.service';
import userApiConfig from './user.config';
import {
    AssignRoleApiPayload,
    DeleteUserRoleApiPayload
} from 'modules/user-management/models/user.model';

export class UserService extends HttpClient {
    public static async getUserList(): Promise<ApiResult<unknown> | undefined> {
        return this.invokeApi(userApiConfig.getUserList());
    }
    public static async deleteRole(
        payload: DeleteUserRoleApiPayload
    ): Promise<ApiResult<boolean> | undefined> {
        return this.invokeApi(userApiConfig.deleteRole(payload));
    }
    public static async assignRole(
        payload: AssignRoleApiPayload
    ): Promise<ApiResult<boolean> | undefined> {
        return this.invokeApi(userApiConfig.assignRole(payload));
    }
    public static async editRole(
        payload: AssignRoleApiPayload
    ): Promise<ApiResult<boolean> | undefined> {
        return this.invokeApi(userApiConfig.editRole(payload));
    }
    public static async getRoleList(payload: any): Promise<ApiResult<unknown> | undefined> {
        return this.invokeApi(userApiConfig.getRoleList(payload));
    }
    public static async getUserRoles(payload: any): Promise<ApiResult<unknown> | undefined> {
        return this.invokeApi(userApiConfig.getUserRoles(payload));
    }
}
